/* eslint-disable no-undef */
import request from './request'
import {getCookie} from "@/helpers";
import logger from "@fortawesome/vue-fontawesome/src/logger";

const getSflAffiliatesForCampaigns = async (data) => {
  try {
    const searchFilter = (!data.searchFilter) ? '' : `(searchFilter: "${data.searchFilter}")`

    const workspace = localStorage.getItem('workspace');

    const result = await request.post(`/graphql`, {
          query: `
          {
            sflAffiliates ${searchFilter} {
              id,
              nameId,
              name,
              email
              status,
              affiliateManagerName
            }
          }
        `
        },
        {
          headers: {
            'Authorization': data.token,
            'Referrer-Police': 'strict-origin-when-cross-origin',
            'Access-Control-Allow-Origin': '*',
            'workspace': workspace
          }
        }
    )

    return {
      affiliates: result.data.data.sflAffiliates,
      entity: data.entity
    }

  } catch (err) {
    console.error(err)
  }
}

const getPendingAffiliates = async (data) => {
  try {

    const result = await request.get(`${process.env.VUE_APP_BACKOFFICE_AFFILIATES_URL}/pendingAffiliates`, {
      params: data.filters,
      headers: {
        'Authorization': data.token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    return result.data

  } catch (err) {
    console.error(err)
  }
}

const getNinetyPlusAffiliates = async (data) => {
  try {

    const result = await request.get(`${process.env.VUE_APP_BACKOFFICE_AFFILIATES_URL}/ninetyPlusAffiliates/`, {
      params: data.filters,
      headers: {
        'Authorization': data.token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    return result.data

  } catch (err) {
    console.log(err)
  }
}

const getNewAffiliates = async (data) => {
  try {

    const result = await request.get(`${process.env.VUE_APP_BACKOFFICE_AFFILIATES_URL}/newAffiliates`,{
      params: data.filters,
      headers: {
        'Authorization': data.token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    return result.data

  } catch (err) {
    console.error(err)
  }
}

const getAffiliatesForAE = async (data) => {
  try {

    const result = await request.get(`${process.env.VUE_APP_BACKOFFICE_AFFILIATES_URL}/affiliatesForAE`, {
      params: data.filters,
      headers: {
        'Authorization': data.token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    return result.data

  } catch (err) {
    console.error(err)
  }
}

const getAffiliatesForAM = async (data) => {
  try {

    const result = await request.get(`${process.env.VUE_APP_BACKOFFICE_AFFILIATES_URL}/affiliatesForAM`, {
      params: data.filters,
      headers: {
        'Authorization': data.token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    return result.data

  } catch (err) {
    console.error(err)
  }
}

const getAffiliatesOM = async (data) => {
  try {

    const result = await request.get(`${process.env.VUE_APP_BACKOFFICE_AFFILIATES_URL}/affiliatesOM`, {
      params: data.filters,
      headers: {
        'Authorization': data.token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    });

    return result.data

  } catch (err) {
    console.error(err)
  }

}

const getAffiliatesHistory = async (id) => {
  try {

    console.time('affiliates history')
    const result = await request.get(`${process.env.VUE_APP_BACKOFFICE_AFFILIATES_URL}/getAffiliatesHistory`, {
      params: {
        affiliateId: id
      },
      headers: {
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })
    console.timeEnd('affiliates history')
    return result.data

  } catch (err) {
    console.error(err)
  }
}

const getAffiliateStatuses = async (data) => {
  try {
    const result = await request.post(`/graphql`, {
          query: `
          {
            affiliateStatuses(searchFilter: "${data.searchFilter}") {
              status
            }
          }
        `
        },
        {
          headers: {
            'Authorization': data.token,
            'Referrer-Police': 'strict-origin-when-cross-origin',
            'Access-Control-Allow-Origin': '*'
          }
        }
    )

    return {
      statuses: result.data.data.affiliateStatuses,
      entity: data.entity
    }

  } catch (err) {
    console.error(err)
  }
}

const getAffiliatesNameId = async (data) => {
  try {

    let queryData = new URLSearchParams()
    queryData.append('search', (!data.searchFilter) ? '' : data.searchFilter)

    const result = await request.get(`${process.env.VUE_APP_BACKOFFICE_AFFILIATES_URL}/getAffiliatesNameId`, {
      params: queryData,
      headers: {
        'Authorization': data.token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    return {
      affiliates: result.data,
      entity: data.entity
    }

  } catch (err) {
    console.error(err)
  }
}

const getAffiliateEmails = async (data) => {
  try {

    data['searchFilter'] = (!data.searchFilter) ? '' : data.searchFilter

    const result = await request.post(`/graphql`, {
          query: `
          {
            affiliateEmails(searchFilter: "${data.searchFilter}") {
              email
            }
          }
        `
        },
        {
          headers: {
            'Authorization': data.token,
            'Referrer-Police': 'strict-origin-when-cross-origin',
            'Access-Control-Allow-Origin': '*'
          }
        }
    )

    return {
      emails: result.data.data.affiliateEmails,
      entity: data.entity
    }

  } catch (err) {
    console.error(`Error while getting affiliate emails: ${err}`)
  }
}

const getAffiliateTypes = async (data) => {
  try {
    const result = await request.post(`/graphql`, {
          query: `
          {
            affiliateTypes(searchFilter: "${data.searchFilter}") {
              type
            }
          }
        `
        },
        {
          headers: {
            'Authorization': data.token,
            'Referrer-Police': 'strict-origin-when-cross-origin',
            'Access-Control-Allow-Origin': '*'
          }
        }
    )

    return {
      types: result.data.data.affiliateTypes,
      entity: data.entity
    }

  } catch (err) {
    console.error(err)
  }
}

const getAffiliateGeos = async (data) => {
  const token = typeof data === 'object' ? data.token : data
  try {
    const result = await request.get(`${process.env.VUE_APP_BACKOFFICE_AFFILIATES_URL}/getAffiliateGeos`, {
      headers: {
        'Authorization': token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    return result.data

  } catch (err) {
    console.error(err)
  }
}

const getAffiliateReferrers = async (data) => {
  try {
    const result = await request.post(`/graphql`, {
          query: `
          {
            affiliateReferrers(searchFilter: "${data.searchFilter}") {
              name
            }
          }
        `
        },
        {
          headers: {
            'Authorization': data.token,
            'Referrer-Police': 'strict-origin-when-cross-origin',
            'Access-Control-Allow-Origin': '*'
          }
        }
    )

    return {
      referrers: result.data.data.affiliateReferrers,
      entity: data.entity
    }

  } catch (err) {
    console.error(err)
  }
}

const getAffiliateDuplicates = async (data) => {
  const token = typeof data === 'object' ? data.token : data
  try {
    const result = await request.get(`${process.env.VUE_APP_BACKOFFICE_AFFILIATES_URL}/getAffiliateDuplicates`, {
      headers: {
        'Authorization': token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    return {
      duplicates: result.data,
      entity: data.entity
    }

  } catch (err) {
    console.error(err)
  }
}

const getAffiliateTiers = async (data) => {
  try {
    const result = await request.post(`/graphql`, {
          query: `
          {
            affiliateTiers(searchFilter: "${data.searchFilter}") {
              tier
            }
          }
        `
        },
        {
          headers: {
            'Authorization': data.token,
            'Referrer-Police': 'strict-origin-when-cross-origin',
            'Access-Control-Allow-Origin': '*'
          }
        }
    )

    return {
      tiers: result.data.data.affiliateTiers,
      entity: data.entity
    }

  } catch (err) {
    console.error(err)
  }
}

const getAffiliatesProfile = async (data) => {
  try {
    let preparedFilters = ''

    for (const filter in data.payload.filters) {
      preparedFilters += (!!data.payload.filters[filter]) ?
          `${filter}: "${data.payload.filters[filter]}"` : ''
    }

    const workspace = localStorage.getItem('workspace');
    const result = await request.post(`/graphql`, {
        query: `
          {
            affiliatesProfile(pagination: {
              page: ${data.payload.page},
              limit: ${data.payload.limit}
            }, sorting: {
              orderBy: "${data.payload.orderBy}",
              orderDirectionAsc: ${data.payload.orderDirectionAsc}
            }, filters: {${preparedFilters}}) {
              count,
              affiliatesProfileData {
                affNameId,
                email,
                affStatus,
                omStatus,
                omCountdown,
                signupDate,
                activationDate,
                paymentType,
                accountExecutive,
                accountManager,
                affType,
                referredBy,
                accountTier,
                highest_tier,
                duplicates,
                custom
              }
            }
          }
        `
      },
      {
        headers: {
          'Authorization': data.token,
          'Referrer-Police': 'strict-origin-when-cross-origin',
          'Access-Control-Allow-Origin': '*',
          'workspace': workspace
        }
      }
    )

    return {
      data: result.data.data.affiliatesProfile.affiliatesProfileData,
      count: result.data.data.affiliatesProfile.count
    }

  } catch (err) {
    console.error(err)
  }
}

const getAffiliatesProfileCO = async (data) => {
  try {
    let preparedFilters = ''

    for (const filter in data.payload.filters) {
      if (data.payload.filters.hasOwnProperty(filter)) {
        const filterValue = data.payload.filters[filter];

        if (filterValue !== undefined && filterValue !== null) {
          let sanitizedFilterValue = filterValue;

          if (Array.isArray(filterValue)) {
            sanitizedFilterValue = `"'${filterValue.join("','")}'"`;
          } else if (typeof filterValue === 'string') {
            sanitizedFilterValue = `"${filterValue.replace(/["]/g, '')}"`;
          } else if (typeof filterValue === 'boolean') {
            sanitizedFilterValue = filterValue ? 'true' : 'false';
          } else if (typeof filterValue === 'number') {
            sanitizedFilterValue = filterValue;
          }

          preparedFilters += `${filter}: ${sanitizedFilterValue},`;
        }
      }
    }

    if (preparedFilters.endsWith(',')) {
      preparedFilters = preparedFilters.slice(0, -1);
    }

    const workspace = localStorage.getItem('workspace');
    const result = await request.post(`/graphql`, {
          query: `
          {
            affiliatesProfileCO(pagination: {
              page: ${data.payload.page},
              limit: ${data.payload.limit}
            }, sorting: {
              orderBy: "${data.payload.orderBy}",
              orderDirectionAsc: ${data.payload.orderDirectionAsc}
            }, filters: {${preparedFilters}}) {
              count,
              affiliatesProfileDataCO {
                affNameId,
                id,
                name,
                email,
                status,
                paymentType,
                currency,
                currencyId,
                currencyName,
                affiliateManager,
                affiliateManagerId,
                billingCycle,
                postbackUrl,
                lastSaleDate,
                isSelectable
                dateAdded,
                verified,
                verticals{
                  id
                  name
                },
                hasDuplicatePaymentMethod,
                hasDuplicatePaymentMethodResolved,
                hasDuplicateName,
                hasDuplicateNameResolved,
                hasDuplicateFingerprint,
                hasDuplicateDeviceId,
                affiliateType,
                activationDate,
                liveDate,
                trafficType,
                tier,
                highest_tier
                parent
                parentId
                paymentTermId
                custom
                trafficType
                affiliateType
                minAmountOverride
                contacts
                companyCount
                streetAddress
                streetAddress2
                city
                state
                postalCode
                country
              }
            }
          }
        `
        },
        {
          headers: {
            'Authorization': getCookie('accessToken'),
            'Referrer-Police': 'strict-origin-when-cross-origin',
            'Access-Control-Allow-Origin': '*',
            'workspace': workspace
          }
        }
    )

    if(result.data.errors) {
      throw new Error(result.data.errors[0].message);
    }

    return {
      data: result.data.data.affiliatesProfileCO.affiliatesProfileDataCO,
      count: result.data.data.affiliatesProfileCO.count
    }

  } catch (err) {
    throw err;
  }
}

const getTopCountries = async () => {
  try {
    const workspace = localStorage.getItem('workspace');
    const platform = await getPlatform();

    const isPlatform2 = platform === 2;
    const query = `
      {
        ${isPlatform2 ? 'hubSpotCountries { code name }' : 'countries { code name phone_code }'}
      }
    `;

    const response = await request.post(
      `/graphql`,
      { query },
      {
        headers: {
          'Authorization': getCookie('accessToken'),
          'Referrer-Policy': 'strict-origin-when-cross-origin',
          'Access-Control-Allow-Origin': '*',
          'workspace': workspace
        }
      }
    );

    const data = response.data.data;
    const countriesFinal = isPlatform2 ? data.hubSpotCountries : data.countries;

    console.log('countriesFinal', countriesFinal);
    return countriesFinal;
  } catch (err) {
    console.error('Error in getTopCountries:', err);
    throw err;
  }
};


const updateAffiliateTopCountries = async (data) => {
  const { affiliateId, added = [], removed = [], newItems = [] } = data;

  const formatArray = (arr) => `[${arr.map(item => `"${item}"`).join(', ')}]`;

  const query = `
    mutation {
      updateAffiliateTopCountries(
        affiliateId: ${affiliateId},
        added: ${formatArray(added)},
        removed: ${formatArray(removed)},
        newItems: ${formatArray(newItems)}
      ) {
        success
        message
      }
    }
  `;

  const result = await request.post(
    '/graphql',
    { query },
    {
      headers: {
        'Authorization': getCookie('accessToken'),
        'Referrer-Policy': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*',
        'workspace': localStorage.getItem('workspace') || 'ac'
      }
    }
  );

  if (result.data.errors) {
    throw new Error(result.data.errors[0].message);
  }

  return result.data.data.updateAffiliateTopCountries;
};


const getAffiliateVerticals = async () => {
  try {
    const workspace = localStorage.getItem('workspace');
    const result = await request.post(`/graphql`, {
          query: `
          {
            getAffiliateVerticals{
                id,
                name
            }
          }
        `
        },
        {
          headers: {
            'Authorization': getCookie('accessToken'),
            'Referrer-Police': 'strict-origin-when-cross-origin',
            'Access-Control-Allow-Origin': '*',
            'workspace': workspace
          }
        }
    )


    return  result.data.data.getAffiliateVerticals

  } catch (err) {
    throw err;
  }
}

const updateAffiliateVerticals = async (data) => {
  const AffiliateVerticals = {
    added: data.added,
    removed: data.removed,
    newItems: data.newItems,
    toSave: data.toSave,
    origin: data.origin
  };

  console.log('updateAffiliateVerticals:', AffiliateVerticals);

  const result = await request.post(`/graphql`, {
        query: `
      mutation UpdateAffiliateVerticals($affiliateId: Int!, $data: VerticalsAffiliate!) {
        updateAffiliateVerticals(affiliateId: $affiliateId, data: $data) 
      }
    `,
        variables: {
          affiliateId: data.id,
          data: AffiliateVerticals
        }
      },
      {
        headers: {
          'Authorization': getCookie('accessToken'),
          'Referrer-Police': 'strict-origin-when-cross-origin',
          'Access-Control-Allow-Origin': '*',
          'workspace': localStorage.getItem('workspace') || 'ac'
        }
      });

  console.log('updateAffiliateVerticals result:', result);
  if (result.data.errors) {
    throw new Error(result.data.errors[0].message);
  }

  if (result.status === 200) {
    if (result.data.data.updateAffiliateVerticals) {
      console.log('updateAffiliateVerticals result.data.data.updateAffiliateVerticals:', result.data.data.updateAffiliateVerticals);
      return result.data.data.updateAffiliateVerticals;
    }
  }
}



const updateAffiliatesAm = async (data) => {
  try {
    console.time('updateAffiliatesAm')

    let queryData = new URLSearchParams()
    queryData.append('managerId', data.managerId)
    queryData.append('affiliates', data.affiliates)
    queryData.append('initiator', data.initiator)


    await request.post(`${process.env.VUE_APP_BACKOFFICE_AFFILIATES_URL}/updateAffiliatesAm`, queryData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    console.timeEnd('updateAffiliatesAm')

    return {
      affiliates: data.affiliates,
      managerId: data.managerId,
      managerName: data.managerName
    }

  } catch (err) {
    console.error(err)
  }
}

const reassignAffiliatesAm = async (data) => {
  try {
    console.time('reassignAffiliatesAm')

    let queryData = new URLSearchParams()
    queryData.append('managerId', data.managerId)
    queryData.append('affiliates', data.affiliates)
    queryData.append('initiator', data.initiator)

    await request.post(`${process.env.VUE_APP_BACKOFFICE_AFFILIATES_URL}/reassignAffiliatesAm`, queryData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    console.timeEnd('reassignAffiliatesAm')

    return {
      affiliates: data.affiliates,
      managerId: data.managerId,
      managerName: data.managerName
    }

  } catch (err) {
    console.error(err)
  }
}

const rejectAffiliates = async (data) => {
  try {
    console.time('rejectAffiliates')

    let queryData = new URLSearchParams()
    queryData.append('affiliate', data.dataReject)

    await request.post(`${process.env.VUE_APP_BACKOFFICE_AFFILIATES_URL}/rejectAffiliates`, queryData, {
      headers: {
        'Authorization': data.token,
        'Content-Type': 'application/x-www-form-urlencoded',
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    console.timeEnd('rejectAffiliates')

    return data.dataReject

  } catch (err) {
    console.error(err)
  }
}

const updateAffsForAEStatus = async (data) => {
  try {

    let queryData = new URLSearchParams()
    queryData.append('affiliate', data.affiliate)
    queryData.append('initiator', data.initiator)

    const route = (data.status === 'suspended') ? 'suspendAffiliates' : 'unsuspendAffiliates'

    await request.post(`${process.env.VUE_APP_BACKOFFICE_AFFILIATES_URL}/${route}`, queryData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    return {
      id: data.affiliate,
      status: data.status
    }

  } catch (err) {
    console.error(err)
  }
}

const updateAffiliatesAe = async (data) => {
  try {
    console.time('updateAffiliatesAe')

    let queryData = new URLSearchParams()
    queryData.append('managerId', data.managerId)
    queryData.append('affiliates', data.affiliates)
    queryData.append('initiator', data.initiator)

    await request.post(`${process.env.VUE_APP_BACKOFFICE_AFFILIATES_URL}/updateAffiliatesAe`, queryData, {
      headers: {
        'Authorization': data.token,
        'Content-Type': 'application/x-www-form-urlencoded',
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    console.timeEnd('updateAffiliatesAe')

    return data.affiliates

  } catch (err) {
    console.error(err)
  }
}

const updateAffiliatesOM = async (data) => {
  try {
    console.time('updateAffiliatesOM')

    const queryData = new URLSearchParams()

    queryData.append('affiliates', data.affiliates)
    queryData.append('initiator', data.initiator)

    await request.post(`${process.env.VUE_APP_BACKOFFICE_AFFILIATES_URL}/updateAffiliatesOM`, queryData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    console.timeEnd('updateAffiliatesOM')

    return data.affiliates

  } catch (err) {
    console.error(err)
  }
}

const approveAffiliate = async (data) => {
  try {

    let queryData = new URLSearchParams()
    queryData.append('affiliateId', data.affiliateId)
    queryData.append('initiator', data.initiator)

    await request.post(`${process.env.VUE_APP_BACKOFFICE_AFFILIATES_URL}/approveAffiliate`, queryData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    return data.affiliateId

  } catch (err) {
    console.error(err)
  }
}

const confirmEmail = async (id) => {
  try {
    console.time('confirmEmail')

    const queryData = new URLSearchParams()

    queryData.append('affiliateId', id)

    await request.post(`${process.env.BACKOFFICE_AFFILIATES_URL}/confirmEmail`, queryData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    console.timeEnd('confirmEmail')

    return id

  } catch (err) {
    console.error(err)
  }
}

const getAffiliateDetailedData = async (data) => {
  try {
    const result = await request.get(`${process.env.BACKOFFICE_AFFILIATES_URL}/getDetailedData?id=${data.id}`, {
      headers: {
        'Authorization': data.token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    return result.data

  } catch (err) {
    console.error(err)
  }
}

const getFilter = async (data) => {
  const preparedFilter = []
  if(data.filter) {
    for (let i = 0; i < data.filter.length; i++) {
      preparedFilter.push(
          (!!data.filter[i]) ? `{ field: "${data.filter[i].field}", value: [${data.filter[i].value.map(v => `"${v}"`)}] }` : ''
      )
    }
  }

  data.filter = preparedFilter ? `filter:[${preparedFilter.join(',')}]` : ''

  const result = await request.post(`/graphql`, {
        query: `
          {
            affiliateFilterData(name: "${data.name}", searchFilter: "${data.searchFilter || ''}", ${data.filter}) {
              key,
              value
            }
          }
        `
      },
      {
        headers: {
          'Authorization': getCookie('accessToken'),
          'Referrer-Police': 'strict-origin-when-cross-origin',
          'Access-Control-Allow-Origin': '*',
          'workspace': localStorage.getItem('workspace') || 'ac'
        }
      }
  )

  if(result.status === 200) {
    const prettyData = [];
    if(result.data.data.affiliateFilterData) {
      for(let i = 0; i < result.data.data.affiliateFilterData.length; i++) {
        prettyData.push(result.data.data.affiliateFilterData[i]);
      }
      return prettyData;
    }
  }
}

const updateAffiliateProfile = async (data) => {
    const AffiliateProfile = `{
      id: ${data.id},
      name: "${data.name}",
      email: "${data.email}",
      status: "${data.status}",
      paymentType: "${data.paymentType}",
      currency: "${data.currency}",
      currencyId: ${data.currencyId},
      currencyName: "${data.currency}",
      affiliateManagerId: ${data.affiliateManagerId},
      billingCycle: "${data.billingCycle}",
      postbackUrl: "${data.postbackUrl}",
      verified: "${data.verified}",
      affiliateType: "${data.affiliateType}",
      trafficType: "${data.trafficType}",
      paymentTermId: ${data.paymentTermId}
      minAmountOverride: ${data.minAmountOverride}
    }`;
    const result = await request.post(`/graphql`, {
          query: `
          mutation{
            updateAffiliateProfile(id: ${data.id}, data: ${AffiliateProfile}) {
              affNameId,
              id,
              name,
              email,
              status,
              paymentType,
              currency,
              currencyId,
              currencyName,
              affiliateManager,
              affiliateManagerId,
              billingCycle,
              postbackUrl,
              lastSaleDate,
              isSelectable, 
              verified,
              dateAdded,
              affiliateType
              paymentTermId
              minAmountOverride
            }
          }
        `
        },
        {
          headers: {
            'Authorization': getCookie('accessToken'),
            'Referrer-Police': 'strict-origin-when-cross-origin',
            'Access-Control-Allow-Origin': '*',
            'workspace': localStorage.getItem('workspace') || 'ac'
          }
        }
    )

    if(result.data.errors) {
      throw new Error(result.data.errors[0].message);
    }

    if (result.status === 200) {
      if (result.data.data.updateAffiliateProfile) {
        return data;
      }
    }
}

const updateAffiliateInfo = async (data) => {
  const AffiliateInfo = `{
    paymentsBlocked: ${data.paymentsBlocked}    
  }`;
  const result = await request.post(`/graphql`, {
        query: `
          mutation{
            updateAffiliateInfo(id: ${data.id}, data: ${AffiliateInfo}) {
              paymentsBlocked
            }
          }
        `
      },
      {
        headers: {
          'Authorization': getCookie('accessToken'),
          'Referrer-Police': 'strict-origin-when-cross-origin',
          'Access-Control-Allow-Origin': '*',
          'workspace': localStorage.getItem('workspace') || 'ac'
        }
      }
  )

  if(result.data.errors) {
    throw new Error(result.data.errors[0].message);
  }

  if (result.status === 200) {
    if (result.data.data.updateAffiliateInfo) {
      return result.data.data.updateAffiliateInfo;
    }
  }
}
const updateAffiliateInfoGotzha = async (data) => {
  const affiliateInfo = `{
    trafficTypes: "${data.trafficTypes}",
    companyName: "${data.companyName}",
    source: "${data.source}"
    affiliateType: "${data.affiliateType}"
  }`;

  const result = await request.post(`/graphql`, {
      query: `
      mutation {
        updateAffiliateInfoGotzha(id: ${data.id}, data: ${affiliateInfo})
      }
    `
    },
    {
      headers: {
        'Authorization': getCookie('accessToken'),
        'Referrer-Policy': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*',
        'workspace': localStorage.getItem('workspace') || 'ac'
      }
    });

  if (result.data.errors) {
    throw new Error(result.data.errors[0].message);
  }

  return result.data.data.updateAffiliateInfoGotzha;
};

const getAffiliateInfo = async ({affiliateId}) => {
  const result = await request.post(`/graphql`, {
      query: `
          {
            affiliateInformation(id: ${affiliateId}) {
              firstName
              lastName
              verticals
              websites
              trafficTypes
              otherNetworks
              topPromotedBrands
              topCountries
              learnSource
              expectedMonthlyRevenue
              paymentMethod
              paymentDetails {
                field
                value
              }
              imType
              imUsername,
              paymentsBlocked
              companyName
              source
              hubspotAffiliateType
            }
          }
        `
    },
    {
      headers: {
        'Authorization': getCookie('accessToken'),
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*',
        'workspace': localStorage.getItem('workspace') || 'ac'
      }
    }
  )

  if(result.data.errors) {
    throw new Error(result.data.errors[0].message);
  }

  if (result.status === 200) {
    if (result.data.data.affiliateInformation) {
      return result.data.data.affiliateInformation;
    }
  }
}

const getAffiliateAddress = async ({affiliateId}) => {
  const result = await request.post(`/graphql`, {
      query: `
          {
            affiliateInformation(id: ${affiliateId}) {
              streetAddress
              streetAddress2
              city
              state
              postalCode
              country
            }
          }
        `
    },
    {
      headers: {
        'Authorization': getCookie('accessToken'),
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*',
        'workspace': localStorage.getItem('workspace') || 'ac'
      }
    }
  )

  if(result.data.errors) {
    throw new Error(result.data.errors[0].message);
  }

  if (result.status === 200) {
    if (result.data.data.affiliateInformation) {
      return result.data.data.affiliateInformation;
    }
  }
}

const getAffiliateHistory = async (id) => {
  try {
    const result = await request.post(`/graphql`, {
        query: `
        {
          getHistory(
            id:${id}
            entity: "affiliate"
          ){
            id
            sflId
            user
            action
            dateAdded
            logs
            
          } 
        }
      `,
      },
      {
        headers: {
          'Authorization': getCookie('accessToken'),
          'Referrer-Police': 'strict-origin-when-cross-origin',
          'Access-Control-Allow-Origin': '*',
          'workspace': localStorage.getItem('workspace') || 'ac'
        }
      }
    )

    return result.data.data.getHistory;
  } catch (e) {
    console.log(e)
  }
}

const getRiskCases = async (id) => {
  try {
    const result = await request.post(`/graphql`, {
          query: `
        {
          cases(
            id:${id}
          ){
            id
            status
            initiator
            reason
            campaignName
            dateAdded
          } 
        }
      `,
        },
        {
          headers: {
            'Authorization': getCookie('accessToken'),
            'Referrer-Police': 'strict-origin-when-cross-origin',
            'Access-Control-Allow-Origin': '*',
            'workspace': localStorage.getItem('workspace') || 'ac'
          }
        }
    )

    return result.data.data.cases;
  } catch (e) {
    console.log(e)
  }
}

const createCase = async (data) => {
  try {
    const result = await request.post(`/graphql`, {
          query: `
            mutation{
              createCase(reason: "${data.reason}", type: "${data.type}", 
                         companyId:${data.companyId}, affiliateId: ${data.affiliateId}, initiator: "${data.initiator}") 
                        {id}
            }
          `,
        },
        {
          headers: {
            'Authorization': getCookie('accessToken'),
            'Referrer-Police': 'strict-origin-when-cross-origin',
            'Access-Control-Allow-Origin': '*',
            'workspace': localStorage.getItem('workspace') || 'ac'
          }
        }
    )

    return result.data.data.createCase;
  } catch (e) {
    console.log(e)
  }
}

const getNotes = async (id) => {
  try {
    const result = await request.post(`/graphql`, {
        query: `
        {
          notes(
            affiliateId:${id}
          ){
            id
            author
            note
            email
            dateAdded
          } 
        }
      `,
      },
      {
        headers: {
          'Authorization': getCookie('accessToken'),
          'Referrer-Police': 'strict-origin-when-cross-origin',
          'Access-Control-Allow-Origin': '*',
          'workspace': localStorage.getItem('workspace') || 'ac'
        }
      }
    )

    return result.data.data.notes;
  } catch (err) {
    console.log(err)
    throw err;
  }
}

const getPings = async (id) => {
  try {
    const result = await request.post(`/graphql`, {
        query: `
        {
          pings(
            affiliateId:${id}
          ){
            id
            url
            statusCode
            attempts
            lastAttempt
            dateAdded
          } 
        }
      `,
      },
      {
        headers: {
          'Authorization': getCookie('accessToken'),
          'Referrer-Police': 'strict-origin-when-cross-origin',
          'Access-Control-Allow-Origin': '*',
          'workspace': localStorage.getItem('workspace') || 'ac'
        }
      }
    )

    return result.data.data.pings;
  } catch (err) {
    console.error(err)
    throw err;
  }
}

const createNote = async (data) => {
  try {
    const result = await request.post(`/graphql`, {
        query: `
            mutation{
              createNote(note: """${data.note}""", affiliateId: ${data.affiliateId}) 
                        {id}
            }
          `,
      },
      {
        headers: {
          'Authorization': getCookie('accessToken'),
          'Referrer-Police': 'strict-origin-when-cross-origin',
          'Access-Control-Allow-Origin': '*',
          'workspace': localStorage.getItem('workspace') || 'ac'
        }
      }
    )

    return result.data.data.createNote;
  } catch (err) {
    console.log(err)
    throw err;
  }
}

const updateNote = async (data) => {
  try {
    const note = data.note.replace(/`/g, '\\`')
    const result = await request.post(`/graphql`, {
          query: `
            mutation{
              updateNote(note: """${note}""", id: ${data.id}, isDelete: ${data.isDelete})
            }
          `,
        },
        {
          headers: {
            'Authorization': getCookie('accessToken'),
            'Referrer-Police': 'strict-origin-when-cross-origin',
            'Access-Control-Allow-Origin': '*',
            'workspace': localStorage.getItem('workspace') || 'ac'
          }
        }
    )

    return result.data.data.updateNote;
  } catch (err) {
    console.log(err)
    throw err;
  }
}

const massUpdate = async data => {
  try {
    const result = await request.post(`/graphql`, {
          query: `mutation{
                    massAffiliateUpdate(status:"${data.status}", ids:[${data.ids}])
                    {
                      id,
                      status
                    }
                }
          `,
        },
        {
          headers: {
            'Authorization': getCookie('accessToken'),
            'Referrer-Police': 'strict-origin-when-cross-origin',
            'Access-Control-Allow-Origin': '*',
            'workspace': localStorage.getItem('workspace') || 'ac'
          }
        }
    )

    return result.data.data.massAffiliateUpdate;
  } catch (e) {
    console.log(e)
  }
}

const massAssign = async data => {
  try {
    const result = await request.post(`/graphql`, {
        query: `mutation {
          massAffiliateAssign(managerId: ${data.managerId}, ids:[${data.ids}])
        }`,
      },
      {
        headers: {
          'Authorization': getCookie('accessToken'),
          'Referrer-Police': 'strict-origin-when-cross-origin',
          'Access-Control-Allow-Origin': '*',
          'workspace': localStorage.getItem('workspace') || 'ac'
        }
      }
    )
    if (result.data.data.massAffiliateAssign) {
      return {
        status: 'success',
        message: result.data.data.massAffiliateAssign,
      };
    } else {
      return {
        status: 'error',
        message: result.data.errors[0].message
      };
    }
  } catch (e) {
    console.log('try', e);
  }
}

const fetchReferralSettings = async (affiliateId) => {
  const result = await request.post(`/graphql`, {
    query: `
      {
        sflAffiliateReferralSettings(affiliateId: ${affiliateId}) {
          referrals
          parent
          commission
          isCommissionEnabled
          isOptionalEarningsEnabled
        }
      }
    `
  },{
    headers: {
      'Authorization': getCookie('accessToken'),
      'Referrer-Police': 'strict-origin-when-cross-origin',
      'Access-Control-Allow-Origin': '*',
      'workspace': localStorage.getItem('workspace') || 'ac'
    }
  })

  return result.data.data.sflAffiliateReferralSettings
}

const updateReferralSettings = async (affiliateId, data) => {
  delete data.maxCommission
  delete data.minCommission

  let preparedQueryString = '{';
  for (const field in data) {
    preparedQueryString += `${field}: ${data[field]},`;
  }
  preparedQueryString += '}'


  return await request.post('/graphql', {
    query: `
      mutation{
        updateReferralSettings(affiliateId: ${affiliateId}, data: ${preparedQueryString})
      }
    `
  }, {
    headers: {
      'Authorization': getCookie('accessToken'),
      'Referrer-Police': 'strict-origin-when-cross-origin',
      'Access-Control-Allow-Origin': '*',
      'workspace': localStorage.getItem('workspace') || 'ac'
    }
  })
}

const affiliateContacts = async (affiliateId) => {
  const result = await request.post(`/graphql`, {
    query: `
      {
        affiliateContacts(affiliate_id: ${affiliateId}) {
          id
          email          
          isPrimary
        }
      }
    `
  },{
    headers: {
      'Authorization': getCookie('accessToken'),
      'Referrer-Police': 'strict-origin-when-cross-origin',
      'Access-Control-Allow-Origin': '*',
      'workspace': localStorage.getItem('workspace') || 'ac'
    }
  })

  return result.data.data.affiliateContacts
}

const getAffiliatePostbacks = async (affiliateId) => {
  const result = await request.post(`/graphql`, {
    query: `
      {
        getAffiliatePostbacks(affiliate_id: ${affiliateId}) {
          id
          postback
        }
      }
    `
  },{
    headers: {
      'Authorization': getCookie('accessToken'),
      'Referrer-Police': 'strict-origin-when-cross-origin',
      'Access-Control-Allow-Origin': '*',
      'workspace': localStorage.getItem('workspace') || 'ac'
    }
  })

  return result.data.data.getAffiliatePostbacks
}

const insertOrUpdateAffiliateContacts = async (affiliateId, contacts) => {
  try {
    const result = await request.post(`/graphql`, {
      query: `
        mutation {
          insertOrUpdateAffiliateContacts(affiliateId: ${affiliateId}, data: [
            ${contacts.map(({ email, isPrimary }) => `{ email: "${email}", isPrimary: ${isPrimary} }`).join(',')}
          ])
        }
      `
    },{
      headers: {
        'Authorization': getCookie('accessToken'),
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*',
        'workspace': localStorage.getItem('workspace') || 'ac'
      }
    });

    return result.data.data.insertOrUpdateAffiliateContacts;
  } catch (error) {
    console.error('Error inserting or updating affiliate contacts:', error);
    return null;
  }
};

const isEmailExists = async (email) => {
  const result = await request.post(`/graphql`, {
    query: `
      {
        isEmailExists(email: "${email}")
      }
    `
  },{
    headers: {
      'Authorization': getCookie('accessToken'),
      'Referrer-Police': 'strict-origin-when-cross-origin',
      'Access-Control-Allow-Origin': '*',
      'workspace': localStorage.getItem('workspace') || 'ac'
    }
  });

  return result.data.data.isEmailExists;
}

const getPlatform = async () => {
  try {

    const result = await request.get(`/platform`,{
      headers: {
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    return result.data

  } catch (err) {
    console.error(err)
  }
}

const getAffiliateCap = async (affiliateId) => {
  const result = await request.post(
      `/graphql`,
      {
        query: `
        query {
          getAffiliateCap(affiliateId: ${affiliateId}) {
            id,
            affiliateId,
            clicksDay,
            clicksWeek,
            clicksMonth,
            clicksRedirectStatus,
            clicksRedirectOfferId,
            clicksRedirectOfferUseDefault,
            salesDay,
            salesWeek,
            salesMonth,
            salesRedirectStatus,
            salesRedirectOfferId,
            salesRedirectOfferUseDefault,
            useStartEndDate,
            startDate,
            endDate,
            enabled,
            status
          }
        }
      `
      },
      {
        headers: {
          Authorization: getCookie('accessToken'),
          'Referrer-Policy': 'strict-origin-when-cross-origin',
          'Access-Control-Allow-Origin': '*',
          workspace: localStorage.getItem('workspace') || 'ac'
        }
      }
  );

  if (result.data.errors) {
    throw new Error(result.data.errors[0].message);
  }

  if (result.status === 200) {
    if (result.data.data.getAffiliateCap) {
      return result.data.data.getAffiliateCap;
    }
  }
};


const updateAffiliateCap = async (data) => {
  data.id = data.id || 0;
  data.clicksRedirectOfferId = data.clicksRedirectOfferId|| 0;
  data.salesRedirectOfferId = data.salesRedirectOfferId|| 0;
  const result = await request.post(
      `/graphql`,
      {
        query: `
        mutation {
          updateAffiliateCap(
            id: ${data.id},
            affiliateId: ${data.affiliateId},
            clicksDay: ${data.clicksDay},
            clicksWeek: ${data.clicksWeek},
            clicksMonth: ${data.clicksMonth},
            clicksRedirectStatus: "${data.clicksRedirectStatus}",
            clicksRedirectOfferId: ${data.clicksRedirectOfferId},
            clicksRedirectOfferUseDefault: ${data.clicksRedirectOfferUseDefault !== undefined ? data.clicksRedirectOfferUseDefault : false},
            salesDay: ${data.salesDay},
            salesWeek: ${data.salesWeek},
            salesMonth: ${data.salesMonth},
            salesRedirectStatus: "${data.salesRedirectStatus}",
            salesRedirectOfferId: ${data.salesRedirectOfferId},
            salesRedirectOfferUseDefault: ${data.salesRedirectOfferUseDefault !== undefined ? data.salesRedirectOfferUseDefault : false},
            useStartEndDate: ${data.useStartEndDate !== undefined ? data.useStartEndDate : false},
            startDate: ${data.startDate ? `"${data.startDate}"` : 'null'},
            endDate: ${data.endDate ? `"${data.endDate}"` : 'null'},
            enabled: ${data.enabled}
          ) {
            id,
            affiliateId,
            clicksDay,
            clicksWeek,
            clicksMonth,
            clicksRedirectStatus,
            clicksRedirectOfferId,
            clicksRedirectOfferUseDefault,
            salesDay,
            salesWeek,
            salesMonth,
            salesRedirectStatus,
            salesRedirectOfferId,
            salesRedirectOfferUseDefault,
            useStartEndDate,
            startDate,
            endDate,
            enabled,
            status
          }
        }
      `
      },
      {
        headers: {
          Authorization: getCookie('accessToken'),
          'Referrer-Policy': 'strict-origin-when-cross-origin',
          'Access-Control-Allow-Origin': '*',
          workspace: localStorage.getItem('workspace') || 'ac'
        }
      }
  );

  if (result.data.errors) {
    throw new Error(result.data.errors[0].message);
  }

  if (result.status === 200) {
    if (result.data.data.updateAffiliateCap) {
      return result.data.data.updateAffiliateCap;
    }
  }
};

const updateAffiliatePostbacks = async (data) => {

  const result = await request.post(
      `/graphql`,
      {
        query: `
          mutation {
            updateAffiliatePostbacks(
              affiliateId: ${data.affiliateId},
              postbacks: ${JSON.stringify(data.postbacks)}
            )
          }
        `
        },
      {
        headers: {
          Authorization: getCookie('accessToken'),
          'Referrer-Policy': 'strict-origin-when-cross-origin',
          'Access-Control-Allow-Origin': '*',
          workspace: localStorage.getItem('workspace') || 'ac'
        }
      }
  );

  if (result.data.errors) {
    throw new Error(result.data.errors[0].message);
  }

  if (result.status === 200) {
    if (result.data.data.updateAffiliatePostbacks) {
      return result.data.data.updateAffiliatePostbacks;
    }
  }
};

const createAffiliate = async (data) => {
  const paymentDetails = JSON.stringify(data.paymentDetails).replace(/"/g, '\\"');
  try {
    const result = await request.post(`/graphql`, {
          query: `
            mutation {
              createAffiliate(
                verticals: ${JSON.stringify(data.verticals)}, 
                traffics: ${JSON.stringify(data.traffics)},
                websites: ${JSON.stringify(data.websites)},
                networks: ${JSON.stringify(data.networks)},
                paymentDetails:"${paymentDetails}" 
                method: ${data.method || null},
                email: "${data.email}",
                firstName: "${data.firstName}",
                lastName: "${data.lastName}",
                imType: "${data.imType || ''}",
                imUsername: "${data.imUsername || ''}",
                topCountries: "${data.topCountries || ''}",
                topOffers: "${data.topOffers || ''}",
                companyName: "${data.companyName || ''}",
                companyAddress: "${data.companyAddress || ''}",
                vat: "${data.vat || ''}",
                revenue: "${data.revenue || ''}",
                term: ${data.term || null}
              ) 
            }
      `,
        },
        {
          headers: {
            'Authorization': getCookie('accessToken'),
            'Referrer-Policy': 'strict-origin-when-cross-origin',
            'Access-Control-Allow-Origin': '*',
            'workspace': localStorage.getItem('workspace') || 'ac'
          }
        });

    return result.data.data.createAffiliate;
  } catch (e) {
    console.log(e);
  }
}

const resetPassword = async (data) => {
  try {
    const result = await request.post(`/graphql`, {
          query: `
            mutation {
              resetPassword(email: "${data.email}")
            }
          `,
          },
          {
            headers: {
              'Authorization': getCookie('accessToken'),
              'Referrer-Policy': 'strict-origin-when-cross-origin',
              'Access-Control-Allow-Origin': '*',
              'workspace': localStorage.getItem('workspace') || 'ac'
            }
          });

    return result.data.data.resetPassword;
  } catch (e) {
    console.log(e);
  }
}
const getAffiliateHubspotTypes = async () => {
  try {
    const result = await request.post(
      `/graphql`,
      {
        query: `
          {
            getAffiliateHubsoptTypes {
              id
              name
            }
          }
        `
      },
      {
        headers: {
          'Authorization': getCookie('accessToken'),
          'Referrer-Policy': 'strict-origin-when-cross-origin',
          'Access-Control-Allow-Origin': '*',
          'workspace': localStorage.getItem('workspace') || 'ac'
        }
      }
    );

    return result.data.data.getAffiliateHubsoptTypes;
  } catch (e) {
    console.error('Failed to load HubSpot affiliate types:', e);
    return [];
  }
};
const getTrafficTypes = async () => {
  try {
    const result = await request.post(
      `/graphql`,
      {
        query: `
          {
            getTrafficTypes {
              name
            }
          }
        `
      },
      {
        headers: {
          'Authorization': getCookie('accessToken'),
          'Referrer-Policy': 'strict-origin-when-cross-origin',
          'Access-Control-Allow-Origin': '*',
          'workspace': localStorage.getItem('workspace') || 'ac'
        }
      }
    );

    return result.data.data.getTrafficTypes;
  } catch (e) {
    console.error('Failed to load traffic types:', e);
    return [];
  }
};

const syncUserHubspot = async (id) => {
  const source = ''
  const result = await request.post(
    `/graphql`,
    {
      query: `
        mutation {
          syncUserHubspot(id: ${id}, source: "${source}")
        }
      `
    },
    {
      headers: {
        'Authorization': getCookie('accessToken'),
        'Referrer-Policy': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*',
        'workspace': localStorage.getItem('workspace') || 'ac'
      }
    }
  );

  if (result.data.errors) {
    throw new Error(result.data.errors[0].message);
  }

  return result.data.data.syncUserHubspot === true;
};


export default {
  getSflAffiliatesForCampaigns,
  getPendingAffiliates,
  getNinetyPlusAffiliates,
  getNewAffiliates,
  getAffiliatesForAE,
  getAffiliatesForAM,
  getAffiliatesHistory,
  getAffiliatesProfile,
  getAffiliatesProfileCO,
  updateAffiliatesAm,
  updateAffiliatesAe,
  updateAffiliatesOM,
  reassignAffiliatesAm,
  approveAffiliate,
  rejectAffiliates,
  updateAffsForAEStatus,
  getAffiliatesNameId,
  getAffiliateTypes,
  getAffiliateStatuses,
  getAffiliateEmails,
  getAffiliateTiers,
  getAffiliatesOM,
  getAffiliateGeos,
  getAffiliateReferrers,
  getAffiliateDuplicates,
  confirmEmail,
  getAffiliateDetailedData,
  getFilter,
  updateAffiliateProfile,
  getAffiliateInfo,
  getAffiliateAddress,
  getAffiliateHistory,
  getRiskCases,
  getAffiliateVerticals,
  getTopCountries,
  createCase,
  createNote,
  getNotes,
  massUpdate,
  getPings,
  massAssign,
  fetchReferralSettings,
  updateReferralSettings,
  updateAffiliateInfo,
  updateAffiliateInfoGotzha,
  updateNote,
  updateAffiliateVerticals,
  getPlatform,
  affiliateContacts,
  insertOrUpdateAffiliateContacts,
  isEmailExists,
  getAffiliateCap,
  getAffiliatePostbacks,
  updateAffiliatePostbacks,
  updateAffiliateCap,
  createAffiliate,
  resetPassword,
  updateAffiliateTopCountries,
  syncUserHubspot,
  getAffiliateHubspotTypes,
  getTrafficTypes
}
